import React, { Fragment, useContext } from 'react';

import clsx from "clsx";

import { useHistory } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

import DropdownAppBarMobile from "./dropdownAppBarMobile";

import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import EmojiNatureIcon from '@mui/icons-material/EmojiNature';

import brandLogo from "../../img/brand-logo.svg";
import menuIcon from "../../img/menu-icon-hexagon.svg";
import { Button } from "@mui/material";

import AppContext from '../../context/AppProvider';

const drawerWidth = 240;

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 150,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

function NotificationDropdown() {
  let history = useHistory()
  const { setNotificationsCount, notificationsCount } = useContext(AppContext);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event, value) => {
    setAnchorEl(null);

    if (value === "goToJobs") {
      setNotificationsCount(0);
      history.push("/dashboard/jobs")
    }
  };

  return (
    <Fragment>

      <IconButton
        id="demo-customized-button"
        aria-controls="demo-customized-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        style={{ color: 'var(--orange)', fontSize: 'large', padding: '0' }}
      >
        <Badge badgeContent={notificationsCount} color="error">
          <NotificationsNoneIcon />
        </Badge>

      </IconButton>
      {notificationsCount > 0 &&
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            'aria-labelledby': 'demo-customized-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >

          <MenuItem onClick={(event) => handleClose(event, "goToJobs")} disableRipple>
            {<EmojiNatureIcon />}
            {`New Jobs Available`}
          </MenuItem>


        </StyledMenu>
      }
    </Fragment>
  )
}

export default function AppBarMobile({ user, drawerState, setDrawerState }) {

  const [open] = React.useState(false);

  const BrandLogo = () => {
    return (
      <a href="/dashboard/jobs">
        <img src={brandLogo} alt="EncoreHive Logo" height="29px" />
      </a>
    )
  }

  const useStyles = makeStyles((theme) => ({
    root: {},
    appBar: {
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      background: "white",
      minHeight: '48px'
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
      color: "var(--greyblue)",
    },
    hide: {
      display: "none",
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },

  }));

  const classes = useStyles();

  const toggleDrawer = (drawerState, setDrawerState) => (event) => {

    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setDrawerState(!drawerState)
  }

  return (

    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
    >
      <Toolbar className="">

        <Grid
          alignItems="center"
          justifyContent="space-between" // Add it here :)
          container
          spacing={0} //was 10 changed to 0
          wrap='nowrap'
        >
          <Grid item >
            <Button onClick={toggleDrawer(drawerState, setDrawerState)}>
              <img src={menuIcon} alt='menu icon' height='24px' />
            </Button>
          </Grid>

          <Grid item >

            <BrandLogo />

          </Grid>

          <div className='navbar-top-items'>

            <div   >
              <NotificationDropdown />
            </div>

            <div  >
              <DropdownAppBarMobile />
            </div>

          </div>

        </Grid>

      </Toolbar>
    </AppBar>

  )
}

